import * as deepmerge from 'deepmerge';
import useQuery from './useQuery';
/**
 * React hook for making a paginated query
 */
const usePaginatedClient = (requester, config) => {
    return useQuery(requester, deepmerge.all([requester.cacheConfig || {}, config || {}, { keepPreviousData: true }]));
};
export default usePaginatedClient;
